import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { useRef as v, useCallback as b, useMemo as G } from "react";
import { c as t } from "../../index-C7ezJk5b.js";
import { a as y, I as C } from "../../close-B57x5Fnk.js";
import { AppId as N } from "../../core/models/PlatformNavigation.js";
import { b as P, S as g } from "../../base-BUIxijjU.js";
import { useIsInternalForApp as k } from "../../core/hooks/useIsInternalForApp.js";
import { cssX as a, cssTI as l } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import { Link as w } from "react-router-dom";
const $ = ({
  autocomplete: n,
  hasResults: c
}) => {
  const r = v(null), m = P(), {
    globalSearch: {
      setIsOpened: i,
      query: o,
      setQuery: u
    },
    userInfo: {
      snapUiUrl: S,
      snapSearchResultsUrl: p
    }
  } = m, f = k(N.Snap), I = b(
    (s) => {
      n && s.key === "ArrowRight" && u(n);
    },
    [n, u]
  ), _ = b(
    (s) => {
      s.preventDefault(), c && r.current && (r.current.click(), i(!1));
    },
    [o, c, S, p, r, i]
  ), h = G(
    () => `${p}${o}`,
    [o, p]
  );
  return /* @__PURE__ */ d(
    "form",
    {
      className: t(a("GlobalSearch__header")),
      onSubmit: _,
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: t(a("GlobalSearch__close-button"), a("Interactive")),
            onClick: () => i(!1),
            "data-testid": l("button", "SearchPopupClose"),
            children: [
              "close ",
              /* @__PURE__ */ e(y, {})
            ]
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: t(a("GlobalSearch__input-label")),
            "data-testid": l("label", "SearchPopupInput"),
            children: "Search for foods, places, articles and more"
          }
        ),
        !!o.trim() && /* @__PURE__ */ e(
          "div",
          {
            className: t(a("GlobalSearch__input-label"), "is-bottom", "is-right"),
            "data-testid": l("label", "SearchPopupInputBelow"),
            children: "or select from below"
          }
        ),
        /* @__PURE__ */ e(
          "input",
          {
            className: t(a("GlobalSearch__input")),
            value: o,
            onChange: (s) => u(s.target.value),
            onKeyDown: I,
            autoFocus: !0,
            "data-testid": l("input", "SearchPopupQuery")
          }
        ),
        /* @__PURE__ */ e(
          "input",
          {
            className: t(a("GlobalSearch__autocomplete")),
            value: n,
            readOnly: !0
          }
        ),
        c && /* @__PURE__ */ e(
          "button",
          {
            className: t(a("GlobalSearch__submit"), a("Interactive")),
            type: "submit",
            "data-testid": l("button", "SearchPopupSubmit"),
            children: /* @__PURE__ */ e(C, {})
          }
        ),
        f && /* @__PURE__ */ e(w, { ref: r, to: h }),
        !f && /* @__PURE__ */ e("a", { ref: r, href: g.getSnapInternalUrl(h, m) })
      ]
    }
  );
};
export {
  $ as default
};
